import { Box, Container, Grid, Tab, Tabs, Typography } from '@mui/material'
import { SyntheticEvent, useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'

import SignIn from '../auth/SignIn'
import SignUp from '../auth/SignUp'
import ErrorFallback from '../components/ErrorFallback'
import LanguageSelect from '../components/LanguageSelect'
import { a11yProps } from '../components/navigation/a11yProps'
import Logo from '../dummy/Uride.png'
import { TabPanelProps } from '../types/interface'

const TabPanel = (props: TabPanelProps) => {
  const { children, index, value, ...other } = props

  return (
    <Box
      aria-labelledby={`simple-tab-${index}`}
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      role="tabpanel"
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  )
}

const Public = () => {
  const [value, setValue] = useState<number>(1)
  const { t } = useTranslation()

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Container
      maxWidth={false}
      sx={{
        backgroundColor: '#FAF9F9',
        minHeight: '100vh',
        p: 2,
      }}
    >
      <Grid
        alignContent="flex-start"
        alignItems="center"
        container
        justifyContent="center"
        spacing={2}
      >
        <Grid
          item
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            mt: 4,
            rowGap: 1,
          }}
          xs={12}
        >
          <img alt="Uride Logo" src={Logo} width="150px" />
          <Typography color="text.primary" variant="body1">
            {t('auth.tagline')}
          </Typography>
        </Grid>
        <Grid
          item
          sx={{
            aligngItems: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
          xs={12}
        >
          <LanguageSelect />
        </Grid>
        <Grid item lg={4} xs={12}>
          <Tabs onChange={handleChange} value={value} variant="fullWidth">
            <Tab label={t('auth.signin.title')} {...a11yProps(0)} />
            <Tab label={t('auth.register.title')} {...a11yProps(1)} />
          </Tabs>

          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <TabPanel index={0} value={value}>
              <SignIn />
            </TabPanel>
            <TabPanel index={1} value={value}>
              <SignUp handleChange={setValue} />
            </TabPanel>
          </ErrorBoundary>
        </Grid>
      </Grid>
    </Container>
  )
}
export default Public
